module.exports = __webpack_public_path__ + "img/telegram.1760ce3c.svg";